import { Component } from '@angular/core';

@Component({
  template: '<div class="col-md-12 text-center" style="padding-top:200px; padding-bottom:250px;"><p style="font-size: 40px;">Такой страницы нет</p><h2 style="font-size: 150px;">404</h2><a class="btn btn-default" routerLink="/">Главная страница</a></div>'
})
export class PageNotFoundComponent { }



// WEBPACK FOOTER //
// /app/SPA/src/app/page-not-found.component.ts